export var Max;
(function (Max) {
    Max[Max["FirstName"] = 75] = "FirstName";
    Max[Max["LastName"] = 75] = "LastName";
    Max[Max["PhoneNumber"] = 25] = "PhoneNumber";
    Max[Max["Email"] = 100] = "Email";
    Max[Max["Name"] = 50] = "Name";
    Max[Max["LongName"] = 100] = "LongName";
    Max[Max["City"] = 100] = "City";
    Max[Max["Address"] = 50] = "Address";
    Max[Max["County"] = 100] = "County";
    Max[Max["State"] = 30] = "State";
    Max[Max["Review"] = 3000] = "Review";
    Max[Max["Note"] = 3000] = "Note";
    Max[Max["ContactIntent"] = 35] = "ContactIntent";
    Max[Max["ContactOutcome"] = 35] = "ContactOutcome";
    Max[Max["Message"] = 3000] = "Message";
})(Max || (Max = {}));
export var Min;
(function (Min) {
    Min[Min["PhoneNumber"] = 25] = "PhoneNumber";
    Min[Min["Name"] = 2] = "Name";
    Min[Min["City"] = 2] = "City";
    Min[Min["Address"] = 7] = "Address";
    Min[Min["County"] = 2] = "County";
    Min[Min["Message"] = 20] = "Message";
    Min[Min["FileUploadEnum"] = 21] = "FileUploadEnum";
})(Min || (Min = {}));
export var Length;
(function (Length) {
    Length[Length["NpiNumber"] = 10] = "NpiNumber";
    Length[Length["PostalCode"] = 5] = "PostalCode";
})(Length || (Length = {}));
export const Patterns = {
    PhoneNumber: /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})(\s*#\d+)?$/,
    Email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
};
const RequiredValidation = (d) => {
    return getValidation(d.path, ValidationType.Required);
};
const InvalidValidation = (d) => {
    return getValidation(d.path, ValidationType.Invalid);
};
const MaxValidation = (d) => {
    const limit = d.max || Max[d.path];
    return getValidation(d.path, ValidationType.Max(limit));
};
const MinValidation = (d) => {
    const limit = d.min || Min[d.path];
    return getValidation(d.path, ValidationType.Min(limit));
};
const LengthValidation = (d) => {
    const limit = d.length || Length[d.path];
    return getValidation(d.path, ValidationType.Length(limit));
};
const EmailValidation = (d) => {
    return getValidation(d.path, ValidationType.Email);
};
export const Validation = {
    Required: RequiredValidation,
    Invalid: InvalidValidation,
    Max: MaxValidation,
    Min: MinValidation,
    Length: LengthValidation,
    Email: EmailValidation
};
const toHumanReadable = (field, toUpperCase = true) => {
    // Support nested paths like "Caregiver.firstName" by only using the last segment.
    const lastSegment = field.split(".").pop() ?? field;
    // Convert from camelCase/PascalCase to snake_case, then normalize to lower case.
    const normalized = lastSegment
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
        .toLowerCase();
    const words = normalized
        .split("_")
        .filter((word) => word && !word.includes("id"));
    return words
        .map((word) => {
        if (!toUpperCase) {
            // For messages like "Please enter a valid first name"
            return word;
        }
        // Title-case each word, e.g. "first" -> "First"
        return word.charAt(0).toUpperCase() + word.slice(1);
    })
        .join(" ");
};
const ValidationType = {
    Required: "is required.",
    Invalid: "Please enter a valid",
    Max: (limit) => `must be less than ${limit} characters.`,
    Min: (limit) => `must be more than ${limit} characters.`,
    Length: (limit) => `must be ${limit} characters.`,
    Email: "Please enter a valid email address"
};
export const getValidation = (field, validationFn) => {
    if (validationFn === ValidationType.Invalid) {
        const humanReadableField = toHumanReadable(field, false);
        return `${ValidationType.Invalid} ${humanReadableField}`;
    }
    const humanReadableField = toHumanReadable(field);
    return `${humanReadableField} ${validationFn}`;
};
